import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import "./loan-calculator.css";

const formatINR = (value) =>
  Number(value).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });

const LoanCalculator = () => {
  const [amount, setAmount] = useState(100000);
  const [days, setDays] = useState(30);
  // Daily interest rate — company minimum 0.9% per day
  const [rate, setRate] = useState(1);

  // Daily interest: e.g. ₹1,00,000 × 1% × 30 days = ₹30,000
  const interest = (amount * rate * days) / 100;
  const total = amount + interest;

  const data = [
    { name: "Loan Amount", value: amount },
    { name: "Interest", value: interest },
  ];

  const COLORS = ["#4eb94a", "#11362b"];

  return (
    <section className="loan-calc__section">
      <div className="container loan-calc__container">
        <div className="text-center mb-5">
          <h2 className="loan-calc__title">Loan Calculator</h2>
          <p className="loan-calc__subtitle">
            Adjust your amount, tenure, and daily interest rate to see your total repayment.
          </p>
        </div>

        <div className="loan-calc__sliders">
          <div className="loan-calc__slider-box">
            <label>Loan Amount: ₹{formatINR(amount)}</label>
            <input
              type="range"
              min="5000"
              max="100000"
              step="1000"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
            />
            <p className="loan-calc__value">₹{formatINR(amount)}</p>
          </div>

          <div className="loan-calc__slider-box">
            <label>Number of Days: {days}</label>
            <input
              type="range"
              min="7"
              max="365"
              value={days}
              onChange={(e) => setDays(Number(e.target.value))}
            />
            <p className="loan-calc__value">{days} Days</p>
          </div>

          <div className="loan-calc__slider-box">
            <label>Daily Interest Rate: {rate}%</label>
            <input
              type="range"
              min="0.9"
              max="1"
              step="0.1"
              value={rate}
              onChange={(e) => setRate(Number(e.target.value))}
            />
            <p className="loan-calc__value">{rate}% / day</p>
          </div>
        </div>

        <div className="loan-calc__results">
          <div className="loan-calc__chart-box">
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={100}
                  paddingAngle={4}
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => `₹${formatINR(value)}`} />
                <Legend verticalAlign="bottom" height={36} />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="loan-calc__details">
            <p>Loan Amount: <span>₹{formatINR(amount)}</span></p>
            <p>Tenure: <span>{days} Days</span></p>
            <p>Daily Interest Rate: <span>{rate}%</span></p>
            <p>Interest Amount: <span>₹{formatINR(interest)}</span></p>
            <p>Total Payable: <span>₹{formatINR(total)}</span></p>
          </div>

          <div className="loan-calc__rates-box">
            <h4>Rates and Charges</h4>
            <ul>
              <li>Loan Amount: ₹5,000 – ₹1,00,000</li>
              <li>Tenure: 7 to 365 Days</li>
              <li>Daily Interest: 0.9% – 1% per day</li>
              <li>No Pre-closure Charges</li>
              <li>No Prepayment Charges</li>
              <li>Net Salary ≥ ₹40,000</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanCalculator;
